import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'

function Publications() {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <article
        style={{
            borderTop: '1px solid ' + theme.palette.lightGrey,
            display: 'flex',
            flexDirection: 'column',
            gap: '40px',
            maxWidth: isLargeScreen ? '1016px' : '100%',
        }}
    >
      <h2 style={{ color: theme.palette.darkGrey }}>
        Publications
      </h2>

      <a href="https://ijic.org/articles/10.5334/ijic.ICIC25427" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey, fontSize: '16px', minWidth: '40px' }}>12. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Pol, Sarah J., <strong>Dorin Manase</strong>, Amanda Silva, Michael Brudno, Robert J. Klaassen, Enid K. Selkirk, Melanie Barwick, Jennifer N. Stinson, and Samantha J. Anthony. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Voxe: A digital health platform to capture patient voices and enhance clinical care."</span>
          <span style={{ color: theme.palette.grey }}> <em>International Journal of Integrated Care</em> 26, no. S1 (2026).</span>
        </p>
      </section>
      </a>

      <a href="https://ijic.org/articles/10.5334/ijic.ICIC24171" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey, fontSize: '16px', minWidth: '40px' }}>11. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Pol, Sarah J., Melanie Barwick, Michael Brudno, Robert J. Klaassen, <strong>Dorin Manase</strong>, Amanda Silva, Jennifer Stinson, Shivali Kapila, and Samantha J. Anthony. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Engaging patients as healthcare partners through the meaningful use of Voxe: A digital patient-reported outcome platform."</span>
          <span style={{ color: theme.palette.grey }}> <em>International Journal of Integrated Care (IJIC)</em> (2025).</span>
        </p>
      </section>
      </a>

      <a href="https://humanfactors.jmir.org/2024/1/e57984" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey, fontSize: '16px', minWidth: '40px' }}>10. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Anthony, Samantha J., Sarah J. Pol, Enid K. Selkirk, Amarens Matthiesen, Robert J. Klaassen, <strong>Dorin Manase</strong>, Amanda Silva et al. </span>
          <span style={{ color: theme.palette.darkGrey }}>"User-centered design and usability of voxe as a pediatric electronic patient-reported outcome measure platform: Mixed methods evaluation study."</span>
          <span style={{ color: theme.palette.grey }}> <em>JMIR Human Factors</em> 11 (2024): e57984.</span>
        </p>
      </section>
      </a>

      <a href="https://www.mdpi.com/2076-393X/12/1/36" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>9. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Walmsley, Sharon, Majid Nabipoor, Leif Erik Lovblom, Rizani Ravindran, Karen Colwill, Alison McGeer, Roya Monica Dayam, <strong>Dorin Manase</strong>, Anne-Claude Gingras, and STOPCoV Team. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Predictors of breakthrough SARS-CoV-2 infection after vaccination."</span>
          <span style={{ color: theme.palette.grey }}> <em>Vaccines</em> 12, no. 1 (2023): 36.</span>
        </p>
      </section>
      </a>

      <a href="https://journals.plos.org/digitalhealth/article?id=10.1371/journal.pdig.0000242" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>8. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Ravindran, Rizani, Leah Szadkowski, Leif Erik Lovblom, Rosemarie Clarke, Qian Wen Huang, <strong>Dorin Manase</strong>, Laura Parente, Sharon Walmsley, and STOPCoV research team. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Decentralized study of COVID vaccine antibody response (STOPCoV): results of a participant satisfaction survey."</span>
          <span style={{ color: theme.palette.grey }}> <em>PLOS Digital Health</em> 2, no. 5 (2023): e0000242.</span>
        </p>
      </section>
      </a>

      <a href="https://www.cell.com/iscience/fulltext/S2589-0042(23)00583-7" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>7. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Walmsley, Sharon L., Leah Szadkowski, Bradly Wouters, Rosemarie Clarke, Karen Colwill, Paula Rochon, Michael Brudno, Rizanni Ravindran, Janet Raboud, Allison McGeer, Amit Oza, Christopher Graham, Amanda Silva, <strong>Dorin Manase</strong>, Peter Maksymowsky, Laura Parente, Roaya Monica Dayam, Jacqueline Simpson, Adrian Pasculescu, and Anne-Claude Gingras. </span>
          <span style={{ color: theme.palette.darkGrey }}>"COVID-19 vaccine antibody responses in community-dwelling adults to 48 weeks post primary vaccine series."</span>
          <span style={{ color: theme.palette.grey }}> <em>iScience</em> 26, no. 4 (2023).</span>
        </p>
      </section>
      </a>

      <a href="https://bmjopen.bmj.com/content/11/10/e053119.abstract" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>6. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Anthony, Samantha J., Sarah J. Pol, Jia Lin, Melanie Barwick, Michael Brudno, <strong>Dorin Manase</strong>, Rulan Savita Parekh, Amanda Silva, and Jennifer Stinson. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Creation of an electronic patient-reported outcome measure platform Voxe: a mixed methods study protocol in paediatric solid organ transplantation."</span>
          <span style={{ color: theme.palette.grey }}> <em>BMJ open</em> 11, no. 10 (2021): e053119.</span>
        </p>
      </section>
      </a>

      <a href="https://www.jtcvs.org/article/S0022-5223(17)31360-0/fulltext" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>5. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Ramroop, Ronand, George Manase, Danny Lu, <strong>Dorin Manase</strong>, Shan Chen, Richard Kim, Teresa Lee et al. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Adrenergic receptor genotypes influence postoperative outcomes in infants in the Single-Ventricle Reconstruction Trial."</span>
          <span style={{ color: theme.palette.grey }}> <em>The Journal of thoracic and cardiovascular surgery</em> 154, no. 5 (2017): 1703-1710.</span>
        </p>
      </section>
      </a>

      <a href="https://www.nature.com/articles/ng.3627" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>4. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Sifrim, Alejandro, Marc-Phillip Hitz, Anna Wilsdon, Jeroen Breckpot, Saeed H. Al Turki, Bernard Thienpont, Jeremy McRae, Tomas W Fitzgerald, Tarjinder Singh, Ganesh Jawahar Swaminathan, Elena Prigmore, Diana Rajan, Hashim Abdul-Khaliq, Siddharth Banka, Ulrike M M Bauer, Jamie Bentham, Felix Berger, Shoumo Bhattacharya, Frances Bu'Lock, Natalie Canham, Irina-Gabriela Colgiu, Catherine Cosgrove, Helen Cox, Ingo Daehnert, Allan Daly, John Danesh, Alan Fryer, Marc Gewillig, Emma Hobson, Kirstin Hoff, Tessa Homfray; The INTERVAL Study, Anne-Karin Kahlert, Ami Ketley, Hans-Heiner Kramer, Katherine Lachlan, Anne Katrin Lampe, Jacoba J Louw, Ashok Kumar Manickaraj, <strong>Dorin Manase</strong>, Karen P McCarthy, Kay Metcalfe, Carmel Moore, Ruth Newbury-Ecob, Seham Osman Omer, Willem H Ouwehand, Soo-Mi Park, Michael J Parker, Thomas Pickardt, Martin O Pollard, Leema Robert, David J Roberts, Jennifer Sambrook, Kerry Setchfield, Brigitte Stiller, Chris Thornborough, Okan Toka, Hugh Watkins, Denise Williams, Michael Wright, Seema Mital, Piers E F Daubeney, Bernard Keavney, Judith Goodship; The UK10K Consortium, Riyadh Mahdi Abu-Sulaiman, Sabine Klaassen, Caroline F Wright, Helen V Firth, Jeffrey C Barrett, Koenraad Devriendt, David R FitzPatrick, J David Brook; The Deciphering Developmental Disorders Study, Matthew Hurles. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Distinct genetic architectures for syndromic and nonsyndromic congenital heart defects identified by exome sequencing."</span>
          <span style={{ color: theme.palette.grey }}> <em>Nature genetics</em> 48, no. 9 (2016): 1060-1065.</span>
        </p>
      </section>
      </a>

      <a href="https://www.nature.com/articles/gim201560" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>3. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>D’Alessandro, Lisa CA, Saeed Al Turki, Ashok Kumar Manickaraj, <strong>Dorin Manase</strong>, Barbara JM Mulder, Lynn Bergin, Herschel C. Rosenberg et al. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Exome sequencing identifies rare variants in multiple genes in atrioventricular septal defect."</span>
          <span style={{ color: theme.palette.grey }}> <em>Genetics in Medicine</em> 18, no. 2 (2016): 189-198.</span>
        </p>
      </section>
      </a>

      <a href="https://link.springer.com/article/10.1186/s12920-014-0067-8" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>2. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}><strong>Manase, Dorin</strong>, Lisa CA D’Alessandro, Ashok Kumar Manickaraj, Saeed Al Turki, Matthew E. Hurles, and Seema Mital. </span>
          <span style={{ color: theme.palette.darkGrey }}>"High throughput exome coverage of clinically relevant cardiac genes."</span>
          <span style={{ color: theme.palette.grey }}> <em>BMC Medical Genomics</em> 7, no. 1 (2014): 67.</span>
        </p>
      </section>
      </a>

      <a href="https://onlinelibrary.wiley.com/doi/full/10.1111/chd.12061" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
      <section style={{ display: 'flex' }}>
        <p style={{ color: theme.palette.grey,fontSize: '16px',  minWidth: '40px' }}>1. </p>
        <p style={{ fontSize: '16px' }}>
          <span style={{ color: theme.palette.grey }}>Marvasti, Tina Binesh, Lisa CA D'Alessandro, <strong>Dorin Manase</strong>, Tanya Papaz, and Seema Mital. </span>
          <span style={{ color: theme.palette.darkGrey }}>"Personalized medicine in the care of the child with congenital heart disease: discovery to application."</span>
          <span style={{ color: theme.palette.grey }}> <em>Congenital heart disease</em> 8, no. 3 (2013): 266-269.</span>
        </p>
      </section>
      </a>

    </article>
  )
}

export default Publications
